import { Button } from 'antd';

import { Props } from './RegistrationHeader.model';

import styles from './RegistrationHeader.module.scss';

const RegistrationHeader = ({ actionLabel, onAction }: Props) => {
	
	return (
		<div className={styles.wrapper}>
			<div className={styles.logo}>
				<img src="logo-grey.png" alt="logo" />

				<div className={styles.bordered}></div>
			</div>

			<div className={styles.userInfo}>
				{ actionLabel &&
					<Button
						size="large"
						onClick={onAction}
					>
						{actionLabel}
					</Button>
				}
			</div>
		</div>
		);
}

export default RegistrationHeader;